import React from "react"

const CTASection = ({ 
  title = "Ready To Build Your Mobile App? Team Up With Us Today.",
  buttonText = "Get A Free App Consultation",
  buttonLink = "/schedule-a-call"
}) => {
  return (
    <div className="cta-section">
      <div className="container cta-container">
        <h2>{title}</h2>
        <a 
          href={buttonLink}
          className="cta-button"
        >
          {buttonText}
        </a>
      </div>
    </div>
  )
}

export default CTASection 